<div class="row">
  <app-file-import class="col-md-5" title="Besuchsdaten" uploadPath="/import/report" (success)="reportsUploaded($event)"
                   (fail)="showError($event)"></app-file-import>

  <app-file-import class="col-md-5 col-md-offset-2" title="Kundendaten" uploadPath="/import/customer"
                   (success)="customerUploaded($event)" (fail)="showError($event)"></app-file-import>
</div>

<div class="row">
  <app-category class="col-md-6" [type]="customerCategoryType" name="Kundenkategorien"
                [formFieldsFactory]="customerFormFields"></app-category>
</div>

<div class="row">
  <mat-card>
    <button mat-raised-button type="button" (click)="exportReports()">Berichte exportieren</button>
  </mat-card>

</div>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/settings.component.html